import store from '@/store';
import AppAccountDelete from '@/../apps/account-delete/index.vue';
import NotificationEmitter from '@/components/NotificationEmitter.vue';

export default {
  components: {
    AppAccountDelete,
    NotificationEmitter,
  },
  store,
};
